export default {
  // these are the default colors used when brand colors are not set
  defaultBrandPrimary: '#D8DFEA',
  defaultBrandSecondary: '#63636E',

  primary: '#37373D', // gray-800
  secondary: '#FF6720',
  error: '#E41B1B',
  link: '#1B6EE4', // blue-600

  white: '#fff',
  black: '#000',

  // TODO: these are some one-off static colors that we should eventually integrate into the palette
  bismark: '#486C8A',

  salmon: {
    '100': '#FDF3F0',
    '200': '#FADBD1',
    '300': '#F3AE97',
    '400': '#EE8E6E',
    '500': '#E96D44',
    '600': '#E44D1B',
    '700': '#BB3F16',
    '800': '#913111',
    '900': '#68230C',
  },

  yellow: {
    '100': '#FFFAEA',
    '200': '#FFF1BF',
    '300': '#FFE071',
    '400': '#FFD339',
    '500': '#FFC700',
    '600': '#D1A300',
    '700': '#A27F00',
    '800': '#745A00',
    '900': '#463600',
  },

  teal: {
    '100': '#F3FAFA',
    '200': '#CDEBE9',
    '300': '#ACDEDA',
    '400': '#6AC3BC',
    '500': '#49B6AD',
    '600': '#3C948D',
    '700': '#2F736E',
    '800': '#21524F',
    '900': '#14312F',
  },

  blue: {
    '100': '#F5F9FE',
    '200': '#EAF2FD',
    '300': '#D1E2FA',
    '400': '#97BDF3',
    '500': '#6EA3EE',
    '600': '#1B6EE4',
    '700': '#165ABB',
    '800': '#0C3268',
    '900': '#071E3E',
  },

  purple: {
    '100': '#F6F3FB',
    '200': '#E5DBF3',
    '300': '#D2BFEA',
    '400': '#B395DB',
    '500': '#8F63CA',
    '600': '#7740BF',
    '700': '#61359C',
    '800': '#4C2979',
    '900': '#361D57',
  },

  green: {
    '100': '#F4FAF4',
    '200': '#ECF7EB',
    '300': '#C5E7C2',
    '400': '#9FD69A',
    '500': '#71C36A',
    '600': '#52B649',
    '700': '#408D39',
    '800': '#2D6529',
    '900': '#1B3D18',
  },

  gray: {
    '100': '#F7F7F7',
    '200': '#F3F3F4',
    '300': '#DADADE',
    '400': '#C2C2C8',
    '500': '#AAAAB2',
    '600': '#797986',
    '700': '#63636E',
    '800': '#37373D',
    '900': '#212125',
  },
};
